import { Link, useNavigate } from "react-router-dom";
import { useLang } from "../App";
import { LOGOS } from "../images";
import { membersI18n } from "../i18n";
import { clearMemberSession } from "../memberAuth";

export default function MemberShell({ children }) {
  const { lang, setLang } = useLang();
  const m = membersI18n[lang];
  const navigate = useNavigate();

  const logout = () => {
    clearMemberSession();
    navigate("/espace");
  };

  return (
    <div className="min-h-screen bg-ink text-ivory">
      <header className="border-b border-ivory/10" data-testid="member-header">
        <div className="flex items-center justify-between px-5 py-5 md:px-10 lg:px-14">
          <Link to="/espace/objets" data-testid="member-logo" aria-label="FLEN Immobilier">
            <img src={LOGOS.horizontalNegativ} alt="FLEN Immobilier" className="h-10 w-auto" />
          </Link>
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-2 text-[11px] tracking-[0.2em] text-ivory/50" data-testid="member-language-switcher">
              {["fr", "de", "en"].map((l, i) => (
                <span key={l} className="flex items-center gap-2">
                  {i > 0 && <span className="text-ivory/20">|</span>}
                  <button
                    data-testid={`member-lang-${l}`}
                    onClick={() => setLang(l)}
                    className={`uppercase transition-colors duration-300 ${lang === l ? "font-semibold text-champagne" : "hover:text-ivory"}`}
                  >
                    {l}
                  </button>
                </span>
              ))}
            </div>
            <Link to="/" className="hidden text-[11px] uppercase tracking-[0.2em] text-ivory/45 transition-colors duration-300 hover:text-ivory md:block">
              FLEN ↗
            </Link>
            <button
              data-testid="member-logout"
              onClick={logout}
              className="border border-ivory/25 px-5 py-2.5 text-[10px] font-semibold uppercase tracking-[0.2em] text-ivory transition-colors duration-500 hover:border-champagne hover:bg-champagne hover:text-ink"
            >
              {m.logout}
            </button>
          </div>
        </div>
      </header>
      {children}
    </div>
  );
}
